import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import LoaderText from '../components/loader/LoaderText';
const AuthRoute = lazy(() => import('./AuthRoute'));
const GuestRoute = lazy(() => import('./GuestRoute'));
const AdminRoute = lazy(() => import('./AdminRoute'));
const UserRoute = lazy(() => import('./UserRoute'));
const FeedbackRoute = lazy(() => import('./FeedbackRoute'));

const AppRoute = () => {
    return (
        <Suspense fallback={<><LoaderText /></>}>
            <Routes>
                <Route path='/auth/*' element={<AuthRoute />}></Route>
                <Route path='/admin/*' element={<AdminRoute />}></Route>
                <Route path='/login' element={<Navigate to='/auth/login' />}></Route>
                <Route path='/reset-password' element={<Navigate to='/auth/reset-password?step=verify-mail' />}></Route>
                <Route path='/feedback/*' element={<FeedbackRoute />}></Route>
                <Route path='/user/*' element={<UserRoute />}></Route>
                <Route path='*' element={<GuestRoute />}></Route>
            </Routes>
        </Suspense>
    );
};

export default AppRoute;